document.addEventListener("DOMContentLoaded", function () {
  const pageUrl = encodeURIComponent(window.location.href);
  const pageTitle = encodeURIComponent(document.title);

  document.querySelectorAll(".social-share-buttons").forEach(group => {
    // Facebook
    group.querySelector(".share-facebook").href =
      `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;

    // Twitter (X)
    group.querySelector(".share-twitter").href =
      `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`;

    // Email
    group.querySelector(".share-email").href =
      `mailto:?subject=${pageTitle}&body=${pageUrl}`;

    // Copy URL
    group.querySelector(".copy-url").addEventListener("click", function () {
      navigator.clipboard.writeText(window.location.href).then(() => {
        alert("URL copied to clipboard!");
      }).catch(err => {
        console.error("Could not copy URL:", err);
      });
    });
  });
});


  class AtcButton extends HTMLElement {
  connectedCallback() {
    const cartType = this.dataset.cartType;
    const variantId = this.getAttribute('value');

    if (!variantId) return;

    this.addEventListener('click', (event) => {
      event.preventDefault();

      // Prepare data for Shopify AJAX API
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(res => res.json())
        .then(data => {
          console.log('Added to cart:', data);

          if (cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }));
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(err => console.error('Error:', err));
    });
  }
}

customElements.define('atc-button', AtcButton);
